import angular from 'angular'

export default class ScrollableController {
  constructor($scope, $attrs, $element, $window, vdWindowDelegate) {
    'ngInject'
    this._$scope = $scope
    this._$attrs = $attrs
    this._$element = $element
    this._$window = $window

    this._vdWindowDelegate = vdWindowDelegate
  }

  $onChanges() {
    this._calcScrollIdentifierOpacity()
  }

  $postLink() {
    this._$attrs.$addClass('vd-scrollable-container')

    this.monobrowElement = angular.element(
      this._$element[0].querySelector('.vd-scrollable-monobrow')
    )
    this.goateeElement = angular.element(
      this._$element[0].querySelector('.vd-scrollable-goatee')
    )
    this.scrollableElement = angular.element(
      this._$element[0].querySelector('.vd-scrollable')
    )

    // When content changes
    const observer = new this._$window.MutationObserver(() =>
      this._calcScrollIdentifierOpacity()
    )
    observer.observe(this.scrollableElement[0], {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    })

    // When content is scrolled; use requestAnimationFrame to schedule the calculation. If the user scrolls
    // quickly the action will take priority, reducing scroll jank (action is called before the next repaint).
    let scrollableRequest
    this.scrollableElement.on('scroll', () => {
      this._$window.cancelAnimationFrame(scrollableRequest)
      scrollableRequest = this._$window.requestAnimationFrame(() =>
        this._calcScrollIdentifierOpacity()
      )
    })

    // When viewport changes
    this._vdWindowDelegate.on(
      this._vdWindowDelegate.EVENTS.resize,
      this._calcScrollIdentifierOpacity,
      this
    )

    // Init
    this._$scope.$applyAsync(() => this._calcScrollIdentifierOpacity())
  }

  $onDestroy() {
    this._vdWindowDelegate.off(
      this._vdWindowDelegate.EVENTS.resize,
      this._calcScrollIdentifierOpacity
    )
  }

  /**
   * Calculates the opacity of the top and bottom scroll identifiers. @note do not make any DOM changes to the
   * scrollableElement in this method, otherwise you will cause an infinite loop as we're binding
   * to 'DOMSubtreeModified'.
   *
   * @private
   *
   * @method _calcScrollIdentifierOpacity
   */
  _calcScrollIdentifierOpacity() {
    if (!this.scrollableElement) {
      return
    }

    const elementNode = this.scrollableElement[0]
    const hasScrollableContent =
      elementNode.scrollHeight > elementNode.clientHeight

    if (!hasScrollableContent) {
      this._setIdentifiersOpacity(0, 0)
      return
    }

    const scrollArea = elementNode.scrollHeight - elementNode.clientHeight
    const percentagePosition = Number(
      elementNode.scrollTop / scrollArea
    ).toFixed(2)

    let topOpacity = 1
    let bottomOpacity = 1

    if (percentagePosition <= 0.1) {
      topOpacity = percentagePosition * 10
    }

    if (percentagePosition >= 0.9) {
      bottomOpacity = (1 - percentagePosition) * 10
    }

    this._setIdentifiersOpacity(topOpacity, bottomOpacity)
  }

  /**
   * Sets the opacity of the top and bo
   *
   * @private
   *
   * @method _setIdentifiersOpacity
   */
  _setIdentifiersOpacity(topOpacity, bottomOpacity) {
    const showMonobrow = angular.isDefined(this.monobrow) ? this.monobrow : true
    const showGoatee = angular.isDefined(this.goatee) ? this.goatee : true

    this.monobrowElement.css('opacity', showMonobrow ? topOpacity : 0)
    this.goateeElement.css('opacity', showGoatee ? bottomOpacity : 0)
  }
}
